
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CreditMemo, CreditMemoLine, ICreditMemo } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';
import { Dictionary } from 'vuex';
import { groupBy } from "lodash-es";

@Component({})
export class CreditMemoDetailsComponent extends ABaseComponent {
    @Prop()
    creditMemoNumber: string;
    creditMemo: ICreditMemo = {};
    creditMemoLinesByPorter: Dictionary<CreditMemoLine[]> = {};

    async created() {
        try {
            let client = ApiProvider.getApiClient();
            let creditMemos = await client.getCreditMemos(this.creditMemoNumber);
            this.creditMemo = creditMemos[0];

            let creditMemoLines = await client.getCreditMemoLines(this.creditMemoNumber);

            this.creditMemoLinesByPorter = groupBy(
                creditMemoLines
                , (item) => {
                    return item.porterNumber;
                }
            );

            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }
}
Vue.component('creditmemo-details', CreditMemoDetailsComponent);